import { database } from "../firebase";
import { ref, get, update, onValue, off } from "firebase/database";
import { idbPut, idbDelete } from "../utils/photo-capture/indexeddb";
import { uploadToSignedUrl } from "../utils/photo-capture/upload-to-signed-url";

export async function fetchScanAddress(userID, uniqueKey) {
  const recordPath = `data/scans/${userID}/${uniqueKey}`;
  const snapshot = await get(ref(database, recordPath));
  if (snapshot.exists()) {
    const data = snapshot.val();
    return data.editedAddress || data.googleMapAddress || "Unknown location";
  }
  return "Unknown location";
}

export async function fetchOriginCoords(userID, uniqueKey) {
  const recordPath = `data/scans/${userID}/${uniqueKey}`;
  const snapshot = await get(ref(database, `${recordPath}/coordinates`));
  return snapshot.val(); // { x, y, acc }
}

export async function updatePhotoData(userID, uniqueKey, payload) {
  const recordPath = `data/scans/${userID}/${uniqueKey}`;
  return update(ref(database, recordPath), payload);
}

export function attachSignedUrlListener(userID, uniqueKey, cb) {
  const recordPath = `data/scans/${userID}/${uniqueKey}`;
  const signedRef = ref(database, `${recordPath}/signedUrlToUploadImage`);
  const unsub = onValue(signedRef, (snap) => {
    if (snap.val()) cb(snap.val());
  });
  return () => {
    off(signedRef);
    if (unsub) unsub();
  };
}

export async function saveImageToIdb(filename, blob) {
  return idbPut(filename, blob);
}

export async function deleteImageFromIdb(filename) {
  return idbDelete(filename).catch(() => {});
}

export async function uploadImageToSignedUrl(url, blob) {
  return uploadToSignedUrl(url, blob);
}
